module.exports = __webpack_public_path__ + "static/media/bilibili.fe104915.png";